import React from "react"
import propTypes from "prop-types"
import Accordion, {
  AccordionItem,
  AccordionHeader,
  AccordionContent
} from "../../../../components/Accordion"
import Answer, {
  AnswerTitle,
  AnswerLabel,
  AnswerDescription,
  AnswerEdit
} from "../../../../components/Answer"
import Card, { Title, Description } from "../../../../components/Card"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardDescription,
  InfoCardEdit,
  InfoCardLabel
} from "../../../../components/InfoCard"
import Button from "../../../../../../components/Button"
import configs from "../../../../../../configs"

const PlanDetails = ({
  aboutMe,
  supportTeam,
  communityActivities,
  removeCommunityActivities
}) => {
  return (
    <div className="row">
      <div className="col-md-8 offset-md-2">
        <Card className="card--green">
          <Title>About Me</Title>
          <Description>
            About You contains information about your disability living
            situation and community involvement. This helps the NDIS understand
            who you are, your current situation and how to best support you.
          </Description>

          <Accordion className="accordion--light">
            {supportTeam && !!supportTeam.length && (
              <AccordionItem>
                <AccordionHeader>My Support Team</AccordionHeader>

                <AccordionContent>
                  {supportTeam.map(member => (
                    <InfoCard key={`support-team-${member.id}`}>
                      <div className="row">
                        <div className="col-md-4">
                          <InfoCardItem>
                            <InfoCardLabel>Name</InfoCardLabel>
                            <InfoCardTitle>
                              {member.first_name} {member.last_name}
                            </InfoCardTitle>
                          </InfoCardItem>

                          <InfoCardItem>
                            <InfoCardLabel>Relationship</InfoCardLabel>
                            <InfoCardTitle>
                              {
                                configs.relationship_labes[
                                  member.relationship.relationship
                                ]
                              }
                            </InfoCardTitle>
                          </InfoCardItem>
                        </div>

                        <div className="col-md-8">
                          <InfoCardItem>
                            <InfoCardLabel>Support Provided</InfoCardLabel>
                            <InfoCardDescription>
                              {member.relationship.support_provided
                                ? member.relationship.support_provided
                                : ""}
                            </InfoCardDescription>
                          </InfoCardItem>
                        </div>
                      </div>
                      <InfoCardEdit
                        href={`/pre-plan/support-team/${member.id}`}
                      >
                        Edit Support Member
                      </InfoCardEdit>
                    </InfoCard>
                  ))}
                </AccordionContent>
              </AccordionItem>
            )}

            {Object.keys(aboutMe).length !== 0 &&
              aboutMe.constructor === Object && (
                <AccordionItem>
                  <AccordionHeader>Support Questions</AccordionHeader>

                  <AccordionContent>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Where do you live and who are the people that support
                        you?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.support_me}>
                        {aboutMe.support_me}
                      </AnswerDescription>

                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/1" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/1">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>Tell us about your daily life.</AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.daily_life}>
                        {aboutMe.daily_life}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/2" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/2">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Tell us about yourself and what you find important in
                        life
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.about_me}>
                        {aboutMe.about_me}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/3" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/3">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Do you currently have any health issues?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription
                        noAnswer={!aboutMe.health_and_wellbeing}
                      >
                        {aboutMe.health_and_wellbeing}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/4" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/4">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        What personal safety concerns do you have?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.safety_concerns}>
                        {aboutMe.safety_concerns}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/5" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/5">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Do you have any issues related to communication?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription
                        noAnswer={!aboutMe.communication_and_decision_making}
                      >
                        {aboutMe.communication_and_decision_making}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/6" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/6">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Are you studying or do you wish to study?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.studying}>
                        {aboutMe.studying}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/7" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/7">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Are you currently employed or would you like to be
                        employed?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.transportation}>
                        {aboutMe.transportation}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/8" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/8">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                    <Answer className="answer--light">
                      <AnswerTitle>
                        Is there any other information that you would like to
                        share about anything that you believe is important in
                        developing your pre-plan?
                      </AnswerTitle>
                      <AnswerLabel>Answer</AnswerLabel>
                      <AnswerDescription noAnswer={!aboutMe.extra_info}>
                        {aboutMe.extra_info}
                      </AnswerDescription>
                      <div className="answer_btns-group">
                        <Button
                          routerLink={{ to: "/pre-plan/about-me/9" }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <AnswerEdit href="/pre-plan/about-me/9">
                          edit
                        </AnswerEdit>
                      </div>
                    </Answer>
                  </AccordionContent>
                </AccordionItem>
              )}

            {communityActivities && !!communityActivities.length && (
              <AccordionItem>
                <AccordionHeader>Community Activities</AccordionHeader>

                <AccordionContent>
                  {communityActivities.map(communityActivity => (
                    <InfoCard
                      onDelete={() => {
                        removeCommunityActivities(communityActivity.id)
                      }}
                      key={`community-activity-${communityActivity.id}`}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <InfoCardItem>
                            <InfoCardLabel>Activity</InfoCardLabel>
                            <InfoCardTitle>
                              {communityActivity.title}
                            </InfoCardTitle>
                          </InfoCardItem>
                        </div>

                        <div className="col-md-8">
                          <InfoCardItem>
                            <InfoCardLabel>
                              Description of Benefits
                            </InfoCardLabel>
                            <InfoCardDescription>
                              {communityActivity.content}
                            </InfoCardDescription>
                          </InfoCardItem>
                        </div>
                      </div>
                      <InfoCardEdit
                        href={`/pre-plan/community-activities/${communityActivity.id}`}
                      >
                        Edit Activity
                      </InfoCardEdit>
                    </InfoCard>
                  ))}
                </AccordionContent>
              </AccordionItem>
            )}
          </Accordion>

          <Button
            routerLink={{ to: "/pre-plan/about-me" }}
            className="btn--secondary-light btn--width-lg btn--height-lg"
          >
            Edit About You
          </Button>
        </Card>
      </div>
    </div>
  )
}

PlanDetails.propTypes = {
  removeCommunityActivities: propTypes.func.isRequired,
  aboutMe: propTypes.shape({
    support_me: propTypes.string,
    daily_life: propTypes.string,
    about_me: propTypes.string,
    health_and_wellbeing: propTypes.string,
    safety_concerns: propTypes.string,
    communication_and_decision_making: propTypes.string,
    studying: propTypes.string,
    transportation: propTypes.string,
    extra_info: propTypes.string
  }),
  supportTeam: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.string,
      first_name: propTypes.string,
      last_name: propTypes.string,
      email: propTypes.string,
      phone: propTypes.string,
      relationship: propTypes.shape({
        relationship: propTypes.string,
        support_provided: propTypes.string
      })
    })
  ),
  communityActivities: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.string,
      title: propTypes.string,
      content: propTypes.string
    })
  )
}

PlanDetails.defaultProps = {
  aboutMe: {},
  supportTeam: [],
  communityActivities: []
}

export default PlanDetails
